import { StatusCode } from '../api/enumerations';

export interface Enveloped {
  detail: { status_code: number; description?: string };
}

/**
 * Same checks every caller did by hand on the API envelope; throws so
 * react-query (or any await) sees the error instead of a "successful" 4xx.
 */
export const unwrap = <T extends Enveloped>(response: T): T => {
  if (response.detail.description) {
    throw new Error(response.detail.description);
  }
  if (response.detail.status_code !== StatusCode.OK) {
    throw new Error('Algo deu errado, tente novamente.');
  }
  return response;
};
